import validator from 'validatorjs';

const validate = (email: string): boolean => {
  if (!email) {
    return true;
  }

  return !!`${email}`.match(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/);

};

validator.register('email', validate, 'email');


// WEBPACK FOOTER //
// ./src/validators/email.ts